export const environment = {
  // portalApi: 'http://localhost/',
  // zakupayToken:"lqpm94qib5j2go47o8is88ant579fa33c0vra3pieaf625bipki8"
  portalApi: 'https://multipod-prodavay.cynteka.ru/',
  zakupayToken:"lqpm94qib5j2go47o8is88ant579fa33c0vra3pieaf625bipki8"
};
